import { CriteriaValue } from '../types';
import { Conditions } from '@trnsact/trnsact-scorecard-sdk';
import { mapCriteriaToConditions } from './mapCriteriaToConditions';

export function getJSONCriteria(conditions: CriteriaValue[]) {
  const scorecardConditions = new Conditions();
  const conditionsForSave = mapCriteriaToConditions(conditions);
  conditionsForSave.forEach(condition => scorecardConditions.addCondition(condition));

  return scorecardConditions.getConditions() as any;
}
